import { ComponentConfig } from '@shared/types/ComponentConfig';

const componentConfig: ComponentConfig = {
  UCHeroGallery: {
    wrapAround: true,
    delay: 10000,
  },
  UCFeatureList: {
    iterateOnMobile: false,
    delay: 5000,
  },
  BannerAspectRatio: {
    aspectRatios: {
      small: { mobile: 1.3, desktop: 5 },
      medium: { mobile: 1, desktop: 3.3 },
      large: { mobile: 0.7, desktop: 2.7 },
    },
  },
  StoryblokWebsiteBanner: {
    categoryPrefix: 'parts',
  },
  ProductDeliveryEstimate: {
    showEstimateButton: true,
    showDeliveryCost: true,
    showDeliveryEstimate: true,
  },
  InStoreAndDelivery: {
    showDeliveryAsCheckmark: false,
  },
  ProductsGridItem: {
    brandLinkByVendor: false,
  },
  ProductCard: {
    showPartNumber: true,
    showSavingsTag: true,
    showCompareAtPrice: true,
    showStockStatusOnly: true,
    hideStockStatus: false,
    showOutOfStock: false,
    alwaysShowViewDetails: false,
    showContactStoreMessage: false,
    hideBrand: false,
    showDigitalPriceRange: false,
  },
  ProductAvailablity: {
    showLowStockCopy: false,
  },
  ProductFitmentBar: {
    emptyStateIcon: 'fa-car',
    doesFitIcon: 'fa-circle-check',
    doesntFitIcon: 'fa-circle-xmark',
    showFitmentStatusLine: true,
  },
  FitmentVehicleDialog: {
    changeVehicleUI: 'dropdown',
  },
  UCFilterPanel: {
    showMobileFilterApplyButton: false,
  },
  UCFiltersConfig: {
    expandAll: false,
    showApproxCounts: false,
  },
  PLPSubcategoryTiles: {
    wrap: false,
    fontSizeMobile: '28px',
  },
  ProductPrice: {
    showPriceRange: false,
  },
};

export default componentConfig;
